import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SparkLineChart } from '@mui/x-charts/SparkLineChart';
import { areaElementClasses } from '@mui/x-charts/LineChart';


export class StatCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      context: this.props.context ? this.props.context : 'paciente',
      dataini: this.props.dataini ? this.props.dataini : new Date().toISOString().substring(0, 10),
      datafim: this.props.datafim ? this.props.datafim : new Date().toISOString().substring(0, 10),
      sexo: this.props.sexo ? this.props.sexo : [1],
      idade: this.props.idade ? this.props.idade : [18,100],
      procedimento: this.props.procedimento ? this.props.procedimento : [1],
      doutor: this.props.doutor ? this.props.doutor : [1],
      title: '---',
      value: '0',
      data: [],
      dataLabel: [],
      trend: 0,
    };
  }
  
  
  componentDidMount = () => {
    this.updateData();
  }; 
  
  
  
  updateStates = (dataini, datafim, sexo, idade, procedimento, doutor) => {
    this.setState({ dataini: dataini, datafim: datafim, sexo: sexo, idade: idade, procedimento: procedimento, doutor: doutor }, () => {this.updateData()} );
  }
  
  
  
  
  updateData = () => {
    if(this.state.context === 'paciente'){
      this.setState({ loading: true });
      this.props.api
        .get('/Dashboard/Patientstatcard/' + this.state.dataini + '/' + this.state.datafim + '/' + this.state.sexo + '/' + this.state.idade + '/' + this.state.procedimento + '/' + this.state.doutor )
        .then((r) => {
          var retValues = this.parseStats(r);
          
          this.setState({
            title: 'Pacientes Novos',
            data: retValues[0],
            dataLabel: retValues[1],
            trend: retValues[2],
            value: retValues[3],
            loading: false,
          });             
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
      
  
    if(this.state.context === '1asessao'){
      this.setState({ loading: true });
      this.props.api
        .get('/Dashboard/FirstSessionstatcard/' + this.state.dataini + '/' + this.state.datafim + '/' + this.state.sexo + '/' + this.state.idade + '/' + this.state.procedimento + '/' + this.state.doutor )
        .then((r) => {
          var retValues = this.parseStats(r);
          
          this.setState({
            title: '1a Sessão',
            data: retValues[0],
            dataLabel: retValues[1],
            trend: retValues[2],
            value: retValues[3],
            loading: false,
          });             
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
    
    
    if(this.state.context === 'revisao'){
      this.setState({ loading: true });
      this.props.api
        .get('/Dashboard/Revisonstatcard/' + this.state.dataini + '/' + this.state.datafim + '/' + this.state.sexo + '/' + this.state.idade + '/' + this.state.procedimento + '/' + this.state.doutor )
        .then((r) => {
          var retValues = this.parseStats(r);
          
          this.setState({
            title: 'Revisão',
            data: retValues[0],
            dataLabel: retValues[1],
            trend: retValues[2],
            value: retValues[3],
            loading: false,
          });             
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
    
    
    if(this.state.context === 'receita'){
      this.setState({ loading: true });
      this.props.api
        .get('/Dashboard/Revenuestatcard/' + this.state.dataini + '/' + this.state.datafim + '/' + this.state.sexo + '/' + this.state.idade + '/' + this.state.procedimento + '/' + this.state.doutor )
        .then((r) => {
          var retValues = this.parseStats(r);
          
          this.setState({
            title: 'Receita (R$)',
            data: retValues[0],
            dataLabel: retValues[1],
            trend: retValues[2],
            value: retValues[3],
            loading: false,
          });             
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
    
        
  }; 
  
  
  parseStats(r){
    var data = [];
    var dataLabel = [];
    var monthName = '';
    var dayNumber = '';
    var fromdate = new Date(this.state.dataini + ' 03:00:00 GMT');
    var todate = new Date(this.state.datafim + ' 03:00:00 GMT');
    for (var d = fromdate; d <= todate; d.setDate(d.getDate() + 1)) {
      dayNumber = d.getDate();
      monthName = d.toLocaleDateString('pt-BR', { month: 'short', })
      dataLabel.push(`${dayNumber} ${monthName}`);
           
      if(r.stats[ d.toISOString().substring(0, 10) ])
        data.push( parseInt( r.stats[ d.toISOString().substring(0, 10) ] ) );
      else
        data.push (0);
    }
    
    var trend = 0;
    if(data && (data[0]>0))
      trend = parseInt( (data[data.length-1] * 100 / data[0]) - 100 );
          
    var value = data.reduce((partialSum, a) => partialSum + a, 0).toLocaleString('pt-BR', {minimumFractionDigits: 0, useGrouping: true})//.toString();
      
    return([data,dataLabel,trend,value]);
  }
    
    
  
  labelColor(){
    if(this.state.trend < -5)
      return '#c30d0d'; //down
    if(this.state.trend > 5)
      return '#52bc52'; //up
    return '#94a0b8'; //neutral
  };
  
  
  
  render() {
    const cardColor = this.labelColor();
  
    return (
      <Card variant='outlined' sx={{ height: '100%', flexGrow: 1 }}>
        <CardContent>
          <Typography component='h2' variant='subtitle2' gutterBottom>
            {this.state.title}
          </Typography>
          <Stack
            direction='column'
            sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1 }}
          >
            <Stack sx={{ justifyContent: 'space-between' }}>
              <Stack
                direction='row'
                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Typography variant='h5' component='p'>
                  <strong>{this.state.value}</strong>
                </Typography>
                <Chip size='small' sx={{color: cardColor, backgroundColor: cardColor+'11', borderColor: cardColor }} label={(this.state.trend < 0) ? ("-" + this.state.trend + "%") : ("+" + this.state.trend + "%")} variant='outlined'/>
              </Stack>
              <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                {'Last ' + this.state.data.length + ' days'}
              </Typography>
            </Stack>
            <Box sx={{ width: '100%', height: 50 }}>
              <SparkLineChart
                colors={[cardColor]}
                data={this.state.data}
                area
                showHighlight
                showTooltip
                xAxis={{
                  scaleType: 'band',
                  data: this.state.dataLabel,
                }}
                sx={{
                  [`& .${areaElementClasses.root}`]: {
                    fill: `url(#area-gradient-${this.state.value})`,
                  },
                }}
              >
                <defs>
                  <linearGradient id={`area-gradient-${this.state.value}`} x1='50%' y1='0%' x2='50%' y2='100%'>
                    <stop offset='0%' stopColor={cardColor} stopOpacity={0.3} />
                    <stop offset='100%' stopColor={cardColor} stopOpacity={0} />
                  </linearGradient>
                </defs>
              </SparkLineChart>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    );
  }
}























